import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCart from '../../hooks/useCart';
import { addCartItems, setCartItems } from '../../store/cartItems';
import CartItem from './CartItem';
import { num2Thousand, removeFromStore } from '../../utils/fn';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import icons from '../../utils/icons.json';
import { setAlert } from '../../store/alert';
import constants from '../../utils/constants.json';
import { Link } from 'react-router-dom';
import ProductSlider from './ProductSlider';
import { setRecentlyViewed } from '../../store/recentlyViewed';

function ShoppingCart() {
	useDocumentTitle('Shopping Cart');

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
	}, []);

	const dispatch = useDispatch();
	const cartItems = useSelector(state => state.cartItems.data);
	const webSettings = useSelector(state => state.webSettings.data);
	const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
	const { items, quantity, total } = useCart(cartItems);

	function clearCart() {
		dispatch(setCartItems([]));
		removeFromStore(constants.CART_ITEMS);
		dispatch(setAlert('Shopping cart cleared'));
	}

	
	function clearRecentlyViewed() {
		dispatch(setRecentlyViewed(null));
		removeFromStore(constants.RECENTLY_VIEWED);
		dispatch(setAlert({ type: 'success', message: 'Recently viewed cleared' }));
	}
	return (
		<div className='main-body shopping-cart-body'>
			<div className='sections'>
				<section className='title'>
					<h2>Shopping Cart</h2>
					{cartItems.length > 0 && <button onClick={clearCart} className='link-btn' type='button' dangerouslySetInnerHTML={{ __html: 'Clear Cart' + icons.trash }} />}
				</section>

				{cartItems.length > 0 && cartItems.map((data, index) => <CartItem key={data.item_code} data={data} />)}
				{cartItems.length == 0 && (
					<div style={{ padding: '20px 10px 200px 10px' }}>
						<p style={{ paddingBottom: '10px' }}>Your Shopping Cart is empty for now.</p>
						<p>Items you add to shopping cart will be listed here.</p>
					</div>
				)}
			</div>
			<div className='cart-items-view sections'>
				{cartItems.length > 0 && (
					<div className='cart-footer'>
						<table>
							<tbody>
								<tr>
									<td>Items in Cart:</td>
									<td>{items}</td>
								</tr>
								<tr>
									<td>Total Quantity:</td>
									<td>{quantity}</td>
								</tr>
								<tr>
									<th>Grand Total:</th>
									<th>
										{webSettings.CURRENCY} {num2Thousand(total)}
									</th>
								</tr>
							</tbody>
						</table>
						<Link to='/checkout' className='btn-checkout flex'>
							Proceed To Checkout
						</Link>
						<button></button>
					</div>
				)}
			</div>
			<div className="sections">
				<section className="title">
					<h3>Recently Viewed</h3>
					{recentlyViewed && recentlyViewed.length > 0 && <button onClick={clearRecentlyViewed} className="link-btn" type="button" dangerouslySetInnerHTML={{ __html: 'Clear' + icons.trash }} />}
				</section>
				{!recentlyViewed && <p style={{ padding: '20px 10px' }}>Products you viewed recently will be displayed here.</p>}
				{recentlyViewed && recentlyViewed.length > 0 && <ProductSlider data={recentlyViewed} />}
			</div>
		</div>
	);
}

export default React.memo(ShoppingCart);
